import { useState } from 'react';

const STORAGE_KEY = 'chukua.dispatch-board.skipped-jobs';

function readSkipped(): string[] {
  try {
    const stored: unknown = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) ?? '[]');
    return Array.isArray(stored) ? stored.filter((id): id is string => typeof id === 'string') : [];
  } catch {
    return [];
  }
}

/** Jobs this dispatcher set aside for the browser session (gitaumoses4/chukua#55). A personal hide, not a job fact, so it is never sent to the server as a change. */
export function useSkippedJobs() {
  const [skippedIds, setSkippedIds] = useState<string[]>(readSkipped);
  const [isShowingSkipped, setIsShowingSkipped] = useState(false);

  function save(next: string[]): void {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    setSkippedIds(next);
  }

  return {
    skippedIds,
    isShowingSkipped,
    setIsShowingSkipped,
    skip: (jobId: string) => save([...new Set([...skippedIds, jobId])]),
    unskip: (jobId: string) => save(skippedIds.filter((id) => id !== jobId)),
  };
}
